import { useFormattedOfferedMaxTerms } from "@faire/deprecated-retailer-visitor-shared/hooks/openWithFaire/useFormattedOfferedMaxTerms";
import {
  StrictLocalizeFunction,
  useStrictLocalization,
} from "@faire/web/common/localization/localize";
import {
  Accordion,
  AccordionItem,
  AccordionProps,
} from "@faire/web/slate-deprecated/Accordion";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";

const getOpenWithFaireLandingPageFaq = (
  formattedOfferedMaxTerms: string,
  strictLocalize: StrictLocalizeFunction
): Array<AccordionItem> => [
  {
    question: strictLocalize({
      id: "mkhO++",
      defaultMessage: "What are 60-day payment terms?",
      description: {
        text: "Question in FAQ section of open with faire landing page",
        img: "https://cdn.faire.com/fastly/0e85b92858453bccebbe594a8404e9f0f63d637a7b56ce69a6397544bc414a82.png",
      },
    }),
    answer: (
      <Typography>
        <StrictLocalMsg
          id="mPfqSO"
          defaultMessage="It’s a payment option that lets you buy inventory and pay up to 60 days later."
          description={{
            text: "Answer in FAQ section of open with faire landing page",
            img: "https://cdn.faire.com/fastly/718221aa16fb7b2c9b52125a709602212c7e87e177b952fe9e0f5a864aef8ee7.png",
          }}
        />
      </Typography>
    ),
  },
  {
    question: strictLocalize({
      id: "1OyQPH",
      defaultMessage: "How do I get a payment terms limit?",
      description: {
        text: "Question in FAQ section of open with faire landing page",
        img: "https://cdn.faire.com/fastly/0e85b92858453bccebbe594a8404e9f0f63d637a7b56ce69a6397544bc414a82.png",
      },
    }),
    answer: (
      <>
        <Typography>
          <StrictLocalMsg
            id="pXpSvd"
            defaultMessage="During sign up, you may get a payment terms limit that you can use to purchase inventory from any brand on Faire. As you pay off your invoices, those amounts are returned to your available payment terms so you can place more orders. If you exceed your limit, any additional orders will be invoiced when they ship."
            description={{
              text: "Answer in FAQ section of open with faire landing page",
              img: "https://cdn.faire.com/fastly/87e451fa366cc554ebc6ca1c2310d83c23412800d848e4bb929c8273a1b08a5c.png",
            }}
          />
          <br />
          <br />
          <StrictLocalMsg
            id="otDCLG"
            defaultMessage="To take advantage of the Open with Faire program and get up to {offeredTermsLimitMoney} in payment terms for your store, you’ll need to submit a short application."
            description={{
              text: "Answer in FAQ section of open with faire landing page",
              img: "https://cdn.faire.com/fastly/87e451fa366cc554ebc6ca1c2310d83c23412800d848e4bb929c8273a1b08a5c.png",
            }}
            values={{
              offeredTermsLimitMoney: formattedOfferedMaxTerms,
            }}
          />
        </Typography>
      </>
    ),
  },
  {
    question: strictLocalize({
      id: "Wuoqm4",
      defaultMessage: "Does it cost anything to use payment terms?",
      description: {
        text: "Question in FAQ section of open with faire landing page",
        img: "https://cdn.faire.com/fastly/0e85b92858453bccebbe594a8404e9f0f63d637a7b56ce69a6397544bc414a82.png",
      },
    }),
    answer: (
      <Typography>
        <StrictLocalMsg
          id="zeEsKr"
          defaultMessage="No, payment terms are just another way to pay for orders on Faire. This benefit isn’t a loan and won’t affect your credit."
          description={{
            text: "Answer in FAQ section of open with faire landing page",
            img: "https://cdn.faire.com/fastly/0e85b92858453bccebbe594a8404e9f0f63d637a7b56ce69a6397544bc414a82.png",
          }}
        />
      </Typography>
    ),
  },
  {
    question: strictLocalize({
      id: "vEoAAz",
      defaultMessage:
        "Will I get penalized for not using all my payment terms?",
      description: {
        text: "Question in FAQ section of open with faire landing page",
        img: "https://cdn.faire.com/fastly/0e85b92858453bccebbe594a8404e9f0f63d637a7b56ce69a6397544bc414a82.png",
      },
    }),
    answer: (
      <Typography>
        <StrictLocalMsg
          id="zbAY69"
          defaultMessage="There is no penalty for not using all of your payment terms. If you've already hit your limit and want to buy more with payment terms, you can pay off an invoice early or apply for an increase."
          description={{
            text: "Answer in FAQ section of open with faire landing page",
            img: "https://cdn.faire.com/fastly/0e85b92858453bccebbe594a8404e9f0f63d637a7b56ce69a6397544bc414a82.png",
          }}
        />
      </Typography>
    ),
  },
  {
    question: strictLocalize({
      id: "nVLrQn",
      defaultMessage: "Do I need to have my store space in order to apply?",
      description: {
        text: "Question in FAQ section of open with faire landing page",
        img: "https://cdn.faire.com/fastly/0e85b92858453bccebbe594a8404e9f0f63d637a7b56ce69a6397544bc414a82.png",
      },
    }),
    answer: (
      <Typography>
        <StrictLocalMsg
          id="q7Ex0i"
          defaultMessage="If you're opening a brick-and-mortar store, we recommend applying for Open with Faire after you get a store space. This increases the likelihood that you'll be able to get an increase to your payment terms limit. If you submit your application without having a store space, you may be asked to submit more information."
          description={{
            text: "Answer in FAQ section of open with faire landing page",
            img: "https://cdn.faire.com/fastly/0e85b92858453bccebbe594a8404e9f0f63d637a7b56ce69a6397544bc414a82.png",
          }}
        />
        <br />
        <br />
        <StrictLocalMsg
          id="k7xLa1"
          defaultMessage="If you’re opening an online store, pop-up shop, or another type of business with a public sales channel, a store space isn’t required."
          description={{
            text: "Answer in FAQ section of open with faire landing page",
            img: "https://cdn.faire.com/fastly/0e85b92858453bccebbe594a8404e9f0f63d637a7b56ce69a6397544bc414a82.png",
          }}
        />
      </Typography>
    ),
  },
];

type OwFAccordionProps = Pick<AccordionProps, "titleAlignment">;

export const OpenWithFaireFAQAccordion: React.FC<OwFAccordionProps> = ({
  titleAlignment,
}) => {
  const { strictLocalize } = useStrictLocalization();
  const formattedOfferedMaxTerms = useFormattedOfferedMaxTerms();

  const landingPageFaqItems: Array<AccordionItem> =
    getOpenWithFaireLandingPageFaq(formattedOfferedMaxTerms, strictLocalize);

  return (
    <Accordion items={landingPageFaqItems} titleAlignment={titleAlignment} />
  );
};
